import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';

/*
 * INTERFACES
 **/
export interface IWidget {
  facilityId: string;
  fontColor: string;
  logo: string;
  language: string;
  facilityHoursStart: number;
  facilityMinsStart: number;
  facilityHoursEnd: number;
  facilityMinsEnd: number;
  widgetPath?:string;
}

@Injectable({
  providedIn: 'root'
})


export class GetWidgetService {
  // image/png
  constructor(private httpClient: HttpClient, private httpHeaderService: HttpHeadersService) { }

  checkFileExtension(file:any):boolean{
    if(file.type == 'image/jpeg' || file.type == 'image/png')
      return true;
    return false;
  }

  public uploadImage(postData: any): Observable<any> {
    const headers=this.httpHeaderService.bearerHttpAuthorizationHeaderWithoutContentType();
    return this.httpClient.post(environment.servicePath + '/equipment/widget/logo',postData, {headers});
    //return this.httpClient.post(environment.servicePath + '/lfuser/upload_profile_photo',postData, {headers});
  }

  public getWidgetDetails(facilityId: string): Observable<IWidget> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/equipment/widget?facilityId='+facilityId, { headers });
    return result as Observable<IWidget>;
  }

  public postWidgetDetails(data: IWidget): Observable<IWidget> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.post(environment.servicePath + '/equipment/widget', data, { headers });
    return result as Observable<IWidget>;
  }
}
